// extracted by mini-css-extract-plugin
export default {"MyButton":"MyButton_MyButton__NNpvh","Loading":"MyButton_Loading__-aDyi","Loader":"MyButton_Loader__Df4ZA","LoaderVisible":"MyButton_LoaderVisible__x+hF3"};